import { styled } from '@clickcease/cc-client-components-lib'
import * as Toast from '@radix-ui/react-toast'

export const ToasterProvider = styled(Toast.Provider, {})

export const ToasterViewport = styled(Toast.Viewport, {
  display: 'flex',
  flexDirection: 'column',
  gap: '$8',
  listStyle: 'none',
  outline: 'none',
  padding: 0,

  marginTop: 0,
  marginBottom: '$4',
  li: {
    width: 'auto',
    '> span': {
      flex: 1,
    },
  },
})
